import React, { useState, useRef } from 'react';
import { Button, Box } from '@mui/material';
import TEXT from './text';
import { useSelector } from 'react-redux';

const ProfileImagePickerComponent = ({ properties, value, valueUpdaterCallback, validityUpdaterCallback }) => {
    const { options = {}, constrains = {} } = properties;
    const language = useSelector(state => state.App_Settings.language);
    const [imagePreview, setImagePreview] = useState(null);
    const [faceDescriptor, setFaceDescriptor] = useState(null);
    const canvasRef = useRef(null);

    const handleFileChange = async (event) => {
        console.log("File input changed:", event);
        const file = event.target.files[0];

        if (!file) {
            return;
        }

        if (constrains.maxSize && file.size > constrains.maxSize) {
            console.error("File size exceeds the maximum allowed size.");
            return;
        }

        if (constrains.accept && !constrains.accept.includes(file.type)) {
            console.error("File type is not allowed.");
            return;
        }

        if (file) {
            const image = await window.faceapi.bufferToImage(file);
            setImagePreview(image);

            try {
                // Detect face descriptor
                const detection = await window.faceapi
                    .detectSingleFace(image)
                    .withFaceLandmarks()
                    .withFaceDescriptor();

                if (detection) {
                    setFaceDescriptor(detection.descriptor);
                    console.log("Face descriptor detected:", detection);

                    // Draw green box
                    const canvas = canvasRef.current;
                    const ctx = canvas.getContext('2d');
                    ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear previous drawings

                    const { _imgDims } = detection.landmarks;
                    const centerX = _imgDims._width / 2 + detection.landmarks._shift._x;
                    const centerY = _imgDims._height / 2 + detection.landmarks._shift._y;

                    const boxSize = 300;
                    const boxX = centerX - boxSize / 2;
                    const boxY = centerY - boxSize / 2;

                    ctx.strokeStyle = 'green';
                    ctx.lineWidth = 2;
                    ctx.strokeRect(boxX, boxY, boxSize, boxSize);
                } else {
                    console.error("No face detected in the image.");
                }
            } catch (error) {
                console.error("Error detecting face:", error);
            }
        }

        // Notify parent component
        if (valueUpdaterCallback) {
            valueUpdaterCallback(file);
        }

        // Update validity
        if (validityUpdaterCallback) {
            const isValid = options.required ? file !== null : true;
            validityUpdaterCallback(isValid);
        }

        if (options.onChange) {
            options.onChange(file);
        }
    };

    return (
        <Box>
            <Button
                variant={options.variant || 'contained'}
                component="label"
            >
                {options.label || TEXT.ImagePicker[language]}
                <input
                    type="file"
                    hidden={true} // Ensure the input is not hidden
                    accept={constrains.accept || 'image/*;capture=camera'}
                    onChange={handleFileChange} // Properly link the onChange handler
                />
            </Button>
            <Box mt={2}>
                {imagePreview && (
                    <div style={{ position: 'relative' }}>
                        <img
                            src={imagePreview.src}
                            alt="Preview"
                            style={{ maxWidth: '100%', height: 'auto' }}
                        />
                        <canvas
                            ref={canvasRef}
                            width={imagePreview.width}
                            height={imagePreview.height}
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                pointerEvents: 'none',
                            }}
                        />
                    </div>
                )}
            </Box>
        </Box>
    );
};

export default ProfileImagePickerComponent;
